import { useState } from "react";
import axios from "axios";
import {
    Alert,
    Box,
    Button,
    Checkbox, CircularProgress,
    Container,
    Divider,
    FormControlLabel,
    FormGroup, Link, Snackbar,
    TextField,
    Typography
} from "@mui/material";

const speakers = [
    "Alessandro Lazzaro - Infettivologo dell’Azienda Ospedaliera Universitaria Policlinico Umberto I di Roma",
    "Davide Moschese - Infettivologo dell’ASST Fatebenefratelli Sacco di Milano",
    "Lorenzo Badia - Infettivologo dell’Azienda AUSL di Imola",
    "Viviana Rizzo - Infettivologa dell’Azienda Ospedaliera dei Colli - PO D. Cotugno di Napoli"
];

const webinars = [
    { id: 1, date: "3 aprile 2025 ore 18.00", topic: "Aderenza terapeutica", topicCheck: "Aderenza terapeutica", guest: "Carlo Oneto, Antinoo Arcigay Napoli" },
    { id: 2, date: "17 aprile 2025 ore 18.00", topic: "Salute sessuale", topicCheck: "Salute sessuale", guest: "Sandro Mattioli, Plus Bologna" },
    { id: 3, date: "8 maggio 2025 ore 18.00", topic: "Benessere psicologico", topicCheck:'Benessere psicologico', guest: "Valeria Calvino - Plus Roma" },
    { id: 4, date: "20 maggio 2025 ore 18.00", topic: "Incontro riepilogativo e conclusivo", topicCheck:'Incontro riepilogativo e conclusivo', guest: "Enrico Caruso, Milano Checkpoint" }
];

function App() {
    const [selectedWebinars, setSelectedWebinars] = useState([]);
    const [email, setEmail] = useState("");
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");


    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setSelectedWebinars((prev) =>
            checked ? [...prev, name] : prev.filter((webinar) => webinar !== name)
        );
    };

    const handleEmailChange = (event) => {
        const newEmail = event.target.value;
        setEmail(newEmail);
        setIsEmailValid(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail)); // Regex per validazione email
    };

    const handleSubmit = async () => {
        setLoading(true);
        const requestData = {
            email,
            ...webinars.reduce((acc, webinar, index) => {
                acc[`webinar${index + 1}`] = selectedWebinars.includes(webinar.topic) ? 'si' : 'no';
                return acc;
            }, {})
        };
        //console.info(requestData);

        try {
            await axios.post("https://hivform-2025-dev-api-37070731175.europe-west1.run.app/register", requestData);
            setSuccess(true);
        } catch (error) {
            setErrorMessage(error.response.data.error || "Errore nell'iscrizione. Riprovare più tardi");
            setOpenSnackbar(true);
        } finally {
            setLoading(false);
        }
    };

    const handlePrivacyChange = (event) => {
        setPrivacyAccepted(event.target.checked);
    };

    const isButtonDisabled = !isEmailValid || selectedWebinars.length === 0 || !privacyAccepted;

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            {/*<img src={'/images/logo.png'} alt={'logo'} />*/}
            <Typography mt={2} variant="h3" gutterBottom color={'#C50F3C'} fontWeight={'bold'}>
                Iscrizione Webinar
            </Typography>
            <Typography variant="h6" paragraph>
                "HIV. Ti va di parlarne?” è una serie di incontri virtuali, organizzati da Gilead Sciences, con infettivologi esperti per saperne di più sull’HIV e sugli aspetti di vita che possono essere migliorati.
            </Typography>

            <Typography variant="h5" gutterBottom>Intervengono</Typography>
            {speakers.map((speaker, index) => (
                <Typography key={index} variant="body1" gutterBottom>- {speaker}</Typography>
            ))}

            <Divider sx={{ my: 2 }} />

            <Typography variant="h5" gutterBottom>Il Programma</Typography>
            {webinars.map((webinar) => (
                <Typography key={webinar.id} variant="body1" gutterBottom>
                    <strong>{webinar.date} - {webinar.topic}</strong> - Ospite: {webinar.guest}
                </Typography>
            ))}

            <Divider sx={{ my: 2 }} />
            {success ?
                <>
                    <Typography sx={{width:'100%'}} variant="h5" gutterBottom textAlign={'center'}>
                        L'iscrizione è avvenuta con successo! <br/>
                        Riceverai una mail di conferma con il link per partecipare al webinar.
                    </Typography>

                </>
                :
                <>
                    <Typography variant="h5" gutterBottom>Seleziona i webinar a cui vuoi partecipare</Typography>
                    <FormGroup>
                        {webinars.map((webinar) => (
                            <FormControlLabel
                                key={webinar.id}
                                control={<Checkbox name={webinar.topicCheck} onChange={handleCheckboxChange} />}
                                label={`${webinar.date} - ${webinar.topicCheck}`}
                            />
                        ))}
                    </FormGroup>

                    <Box mt={2}>
                        <TextField
                            fullWidth
                            label="Inserisci la tua email per iscriverti"
                            variant="outlined"
                            value={email}
                            onChange={handleEmailChange}
                            error={email.length > 0 && !isEmailValid}
                            helperText={email.length > 0 && !isEmailValid ? "Inserisci un'email valida" : ""}
                        />
                    </Box>

                    <FormControlLabel
                        control={<Checkbox checked={privacyAccepted} onChange={handlePrivacyChange} />}
                        label={<><Typography variant="body2">Dichiaro di aver preso visione dell' <Link href={"/privacy-policy.pdf"} target={"_blank"}>informativa privacy*</Link></Typography></>}
                    />


                    <Box mt={3}>
                        <Button
                            variant="contained"
                            sx={{ backgroundColor: '#C50F3C', minHeight:'50px' }}
                            fullWidth
                            onClick={handleSubmit}
                            disabled={isButtonDisabled} // Disabilitazione dinamica
                        >
                            {loading ? <CircularProgress sx={{color:'white'}} size={20}/> : 'Iscriviti ai webinar'}
                        </Button>
                    </Box>
                </>
            }

            <img src={'/images/locandina.png'} alt={'locandina'} width={'100%'} style={{marginTop:'15px'}}/>
            {/* Snackbar per errori */}
            <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={() => setOpenSnackbar(false)}>
                <Alert onClose={() => setOpenSnackbar(false)} severity="error" sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default App;
